<div class="nes-hidden lg:nes-flex nes-flex-col nes-items-center nes-mb-24">
  <h2 class="nes-text-inverse-subdued nes-text-1000 nes-font-bold nes-mb-5">
    {{ 'ADVICE.KETENDIENSTEN.HEADER' | translate }}
  </h2>
  <p class="nes-text-inverse-subdued nes-text-center nes-inline-block nes-w-fit nes-mb-10">
    {{ 'ADVICE.KETENDIENSTEN.TEXT' | translate }}
  </p>
  <img src="/assets/images/ketendiensten.png" alt="afbeeldingen van ketendiensten">
</div>